module.exports = __webpack_public_path__ + "static/media/50.717ed2d1.gif";